import { useGenericActivityFromElysiumMutation } from "src/api/client/generic-activity-from-elysium.api";
import { EnumActivityType } from "src/api/client/generic-activity.api";
import { createMiddleClickHandler } from "src/utils/dom/mouse/mouse";
import { IAdProps } from "./ad.types";
import { MediaContentCard } from "./media-content-card";

const AD_MODULE_TEST_ID = "ad-module";

export const Ad = (props: IAdProps) => {
    const { headline, description, link, nodeId, image } = props;
    const genericActivity = useGenericActivityFromElysiumMutation();

    const onLinkClick = () => {
        genericActivity({
            activityTypeId: EnumActivityType.AdClicked,
            parameter: JSON.stringify({ nodeId, targetUrl: link.url }),
            referrer: window.location.href,
        });
    };

    return (
        <MediaContentCard
            imageSx={{ height: ["auto", "auto", "105px", "110px"] }}
            title={headline}
            description={description}
            link={link}
            image={image}
            srcSet={[{ queryParams: { w: 256, fit: "crop" } }]}
            testId={AD_MODULE_TEST_ID}
            onLinkClick={onLinkClick}
            onAuxClick={createMiddleClickHandler(onLinkClick)}
        />
    );
};
